import RelayEnvironment from './environment';

export const getRelayEnvironment = () => RelayEnvironment;
